import { render, staticRenderFns } from "./RadioButtonBox.vue?vue&type=template&id=c8fb86da&scoped=true"
import script from "./RadioButtonBox.vue?vue&type=script&lang=ts"
export * from "./RadioButtonBox.vue?vue&type=script&lang=ts"
import style0 from "./RadioButtonBox.vue?vue&type=style&index=0&id=c8fb86da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fb86da",
  null
  
)

export default component.exports